export default {
  // 是否显示话题的左箭头
  topics_show_arrow_left: false,
  // 是否显示话题的右箭头
  topics_show_arrow_right: false
};